import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomDownload = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props}>
        <path d="M12 16L17.7 10.3L16.29 8.88L13 12.18V2.59H11V12.18L7.7 8.88L6.29 10.3L12 16ZM21 15L20.98 18.51C20.98 19.89 19.86 21 18.48 21H5.5C4.11 21 3 19.88 3 18.5V15H5V18.5C5 18.78 5.22 19 5.5 19H18.48C18.76 19 18.98 18.78 18.98 18.5L19 15H21Z" />
    </SvgIcon>
);
